// ID события не равен номеру сделки; передаём оба и фиксируем текущий цикл.
export function surveyorSupplementPath(event) {
  const query = new URLSearchParams({ event: String(event.id) });
  if (event.additional_measurement?.status === 'active') query.set('additional', String(event.additional_measurement.id));
  return `/surveyor/supplement/${event.bitrix_deal.id}?${query}`;
}